import { Popover as muiPopover } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { fontFamily } from 'stylesheet';
import { borderRadius, getSpacing } from 'stylesheetB2b';

export const Popover = muiStyled(muiPopover)({
  '& .MuiPaper-root': {
    backgroundColor: 'inherit',
  },
  '& .MuiPaper-rounded': {
    borderRadius: 10,
  },
});

export const MenuContainer = styled.div<{ colors: ColormapInterface }>`
  display: flex;
  flex-direction: column;
  font-family: ${fontFamily.main};
  border-radius: ${borderRadius.large};
  user-select: none;

  :not(:last-child) {
    border-bottom: solid ${getSpacing(0.1)} ${({ colors }) => colors.popoverItemBorder};
  }

  :last-child {
    border: 0;
  }
`;
